import { Flex, Typography } from "antd"
import cls from "classname"

import Private from "../../../../../Components/Private"
import { getStatusIcon } from "../../../VAMP/utils/getMonitoringMonthIcon"
import { MONTH_STATUSES } from "../monitoringCopy"
import MonthStatusTrigger from "../MonthStrip/MonthStatusTrigger"

import "./MonthCell.less"

const { Text } = Typography

const MonthCell = ({
  month,
  lines = [],
  isCurrent,
  popover,
  isMobile = false,
  isPrivate = false
}) => {
  const { icon, variant } = getStatusIcon(month?.status)
  const isLocked = month?.status === MONTH_STATUSES.NO_STATUS

  const valueNode = (line, index) => (
    <Text key={index} type="secondary" className={cls("month-cell__value", { locked: isLocked })}>
      {isPrivate && index === 0 ? <Private>{line}</Private> : line}
    </Text>
  )

  return (
    <Flex
      className={cls("month-cell", { current: isCurrent, "is-mobile": isMobile })}
      vertical
      align={isMobile ? "flex-start" : "center"}
      gap={8}
    >
      <Flex align="center" gap={8}>
        <MonthStatusTrigger
          icon={icon}
          variant={variant}
          status={month?.status}
          monthName={month?.month_name}
          popover={popover}
        />
        {isMobile && <Text className="month-cell__name">{month?.month_name}</Text>}
      </Flex>
      {!isMobile && (
        <Text type="secondary" className="month-cell__name">
          {month?.month_name}
        </Text>
      )}
      <Flex vertical align={isMobile ? "flex-start" : "center"} gap={2}>
        {lines.map(valueNode)}
      </Flex>
    </Flex>
  )
}

export default MonthCell
